import styled from"@emotion/styled";import{topPriorityBannerStyles}from"./atoms";import DemoModeBanner from"./demoModeBanner";export const TopPriorityDemoModeBanner=styled(DemoModeBanner)`
  ${topPriorityBannerStyles}
`;